import { BrowserRouter, Route, Routes } from 'react-router';
import {Client as Styletron} from 'styletron-engine-atomic';
import {Provider as StyletronProvider} from 'styletron-react';
import { DarkTheme, BaseProvider} from 'baseui';

import * as ROUTES from './Routes';
import NotFound from './404';
import './App.css';
import PrivacyPolicy from './Privacy';
import Home from './Home';
import Wall from './Wall';
import Navigation from './Navigation';
import About from './About';
import Microsoft from './Platforms/Windows';
import Apple from './Platforms/MacOS';
import Linux from './Platforms/Linux';
import Android from './Platforms/Android';
import Support from './Support';

const engine = new Styletron();

function App() {
  return (
    <div style={{maxWidth: '1500px', margin: 'auto'}}>
        <StyletronProvider value={engine}>
          <BaseProvider theme={DarkTheme}>
              <Navigation />
              <BrowserRouter>
                <Routes>
                  <Route path={ROUTES.HOME} element={<Home />} />
                  <Route path={ROUTES.WALL} element={<Wall />} />
                  <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
                  <Route path={ROUTES.ABOUT} element={<About />} />
                  <Route path={ROUTES.MICROSOFT} element={<Microsoft />} />
                  <Route path={ROUTES.APPLE} element={<Apple />} />
                  <Route path={ROUTES.LINUX} element={<Linux />} />
                  <Route path={ROUTES.ANDROID} element={<Android />} />
                  <Route path={ROUTES.SUPPORT} element={<Support />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
          </BaseProvider>
        </StyletronProvider>
    </div>
  );
}

export default App;
